module.exports = __webpack_public_path__ + "img/alg7.364d4b1e.png";